export function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return `${views}`;
}

export function formatDate(date: string): string {
  const parts = date.split('-');
  if (parts.length !== 3) return date;
  return `${parts[0]}年${Number(parts[1])}月${Number(parts[2])}日`;
}